<template>
  <a-layout>
    <a-layout-header class="header">
      <div class="logoDiv">
        <img src="../../assets/mxmLogo.png" class="logo" width="35" height="35">
        <span>密小盟 · 质量中心</span>
      </div>
      <a-menu v-model:selectedKeys="selectedKeys1" theme="dark" mode="horizontal" @click="handelTopMenuClick"
        :style="{ lineHeight: '64px' }">
        <a-menu-item key="1">待办任务</a-menu-item>
        <a-menu-item key="2">缺陷列表</a-menu-item>
        <a-menu-item key="3">质量大盘</a-menu-item>
      </a-menu>
    </a-layout-header>
    <a-layout>
      <a-layout-sider v-model:collapsed="collapsed" :trigger="null" collapsible width="200" style="background: #fff">
        <a-menu v-model:selectedKeys="selectedKeys2" v-model:openKeys="openKeys" mode="inline" @click="handelClick"
          @openChange="onOpenChange" :style="{ height: '100%', borderRight: 0 }">
          <a-sub-menu key="datawork">
            <template #title>
              <span>
                <star-outlined />
                <span>测试造数工厂</span>
              </span>
            </template>
            <a-menu-item key="/datawork/list">造数场景</a-menu-item>
            <a-menu-item key="/datawork/templates">模版管理</a-menu-item>
            <a-menu-item key="/datawork/records">调用记录</a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="perf">
            <template #title>
              <span>
                <line-chart-outlined />
                <span>性能测试</span>
              </span>
            </template>
            <a-menu-item key="/perf/mqtt">MQTT压测</a-menu-item>
            <a-menu-item key="/perf/http">HTTP压测</a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="metersphere">
            <template #title>
              <span>
                <ci-circle-outlined />
                <span>接口自动化测试</span>
              </span>
            </template>
            <a-menu-item key="/metersphere/testplan">自动化巡检</a-menu-item>
            <a-menu-item key="/metersphere/report">巡检测试报告</a-menu-item>

          </a-sub-menu>
          <!-- <a-sub-menu key="uitest">
            <template #title>
              <span>
                <block-outlined />
                <span>UI自动化测试</span>
              </span>
            </template>
            <a-menu-item key="/uitest/UIAutoTest">持续集成</a-menu-item>
            <a-menu-item key="/uitest/UIAutoTestReport">UI自动化测试报告</a-menu-item>
          </a-sub-menu> -->
        </a-menu>
        <div class="ant-layout-sider-trigger">
          <menu-unfold-outlined v-if="collapsed" class="trigger" @click="() => (collapsed = !collapsed)" />
          <menu-fold-outlined v-else class="trigger" @click="() => (collapsed = !collapsed)" />
        </div>
      </a-layout-sider>
      <a-layout style="padding: 0 24px 24px">
        <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }">
          <router-view></router-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>
<script>
import { UserOutlined, SmileOutlined, LineChartOutlined, TeamOutlined, FileOutlined, MenuFoldOutlined, MenuUnfoldOutlined, StarOutlined, BlockOutlined, CiCircleOutlined } from '@ant-design/icons-vue';
import { defineComponent, ref } from 'vue';

import Routes from "@/router";
export default {
  components: {
    UserOutlined,
    SmileOutlined,
    LineChartOutlined,
    TeamOutlined,
    FileOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    StarOutlined,
    BlockOutlined,
    CiCircleOutlined
  },
  data() {
    return {
      selectedKeys1: [],
      selectedKeys2: [],
      collapsed: false,
      openKeys: [],
      rootOpenKeys: ['datawork','perf','metersphere','uitest'],
    };
  },
  mounted() {
    this.updateMenu();
  },
  methods: {
    handelClick(item) {
      if (item.key !== this.$route.path) {
        // console.log("key:", item.key)
        this.$router.push(item.key)
      }
    },
    handelTopMenuClick(item) {
      if (item.key !== this.$route.path) {
        // console.log("key:", item.key);
      }
    },
    updateMenu() {
      const routes = this.$route.matched.concat()
      this.selectedKeys2 = [routes.pop().path]
      // console.log("selectedKeys2:",this.selectedKeys2);
      // console.log("rootOpenKeys:",this.rootOpenKeys);

      const keysItem =this.rootOpenKeys.find(item => {
        // console.log("item:",this.$route.path.indexOf(item) );
        return this.$route.path.indexOf(item) !== -1
      })
      // console.log("keysItem:",keysItem);
      if(keysItem){
        this.openKeys=[keysItem];
      }
    
    },

    onOpenChange(openKeys) {
      this.rootOpenKeys = openKeys
    }
  },
  watch: {
    '$route'(val) {
      this.updateMenu()
    }
  }
};
</script>
<style>
.ant-layout{
   min-height: 655px;
}
.ant-row-rtl #components-layout-demo-top-side-2 .logo {
  float: right;
  margin: 16px 0 16px 24px;
}

.site-layout-background {
  background: #fff;
}

.logoDiv {
  float: left;
  width: 200px;
  height: auto;
  font-size: 18px;
  color: #fff;
}

.logo {
  margin-right: 5px;
}

.header {
  padding-left: 20px;
}

.ant-layout-sider-trigger:hover {
  color: #1890ff;
}

.ant-layout-sider-trigger {
  width: auto;
  min-width: 80px;
  max-width: 120px;
  position: fixed;
  bottom: 0;
  z-index: 1;
  height: 48px;
  color: #fff;
  line-height: 48px;
  text-align: center;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  color: #666;
}
</style>